import React, { useState, useEffect, useRef } from 'react';
import CareerProgressBar from '../Components/CareerProgressBar';
import aiAvatar from '../Assets/kumar-avatar.png';
import userAvatar from '../Assets/User-avatar.png';
import ChatBubble from '../Components/Chatbubble';
import MessageInput from '../Components/MessageInput';
import TypingDots from '../Components/TypingDots';
import { callOpenAI } from '../utils/openaiService';

const Roadmap = () => {
  const [levelNumber, setLevelNumber] = useState(1);
  const [chatLog, setChatLog] = useState([
    {
      sender: 'ai',
      avatar: aiAvatar,
      name: 'Kumar',
      message: `Alright, we’ve got your goals.  
Now let’s turn that dream into a game plan. 🎯  
Here’s the roadmap that’ll take you there — step-by-step. I’ll guide you at every level. Let’s start with Level 1?`,
    },
  ]);

  const [isThinking, setIsThinking] = useState(false);
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [chatLog, isThinking]);

  const handleUserResponse = async (userText) => {
    const newChat = [
      ...chatLog,
      {
        sender: 'user',
        avatar: userAvatar,
        name: 'You',
        message: userText,
      },
    ];

    const formattedMessages = newChat.map((msg) => ({
      role: msg.sender === 'ai' ? 'assistant' : 'user',
      content: msg.message,
    }));

    const prompt = `Please continue guiding me through my personalized roadmap.`;

    setIsThinking(true);

    const reply = await callOpenAI({
      messages: [...formattedMessages, { role: 'user', content: prompt }],
      screenContext: 'roadmap',
    });

    setIsThinking(false);

    setChatLog([
      ...newChat,
      {
        sender: 'ai',
        avatar: aiAvatar,
        name: 'Kumar',
        message: reply,
      },
    ]);

    // Optional: Simulate Level Up based on some logic
    if (chatLog.length % 6 === 0) {
      setTimeout(() => {
        setLevelNumber((prev) => Math.min(prev + 1, 5));
        setChatLog((prev) => [
          ...prev,
          {
            sender: 'ai',
            avatar: aiAvatar,
            name: 'Kumar',
            message: `🎉 Awesome! You’re now ready to begin **Level ${levelNumber + 1}**. Let’s level up your journey from here!`,
          },
        ]);
      }, 3000);
    }
  };

  return (
    <div className="w-full max-w-[1000px] mx-auto p-6 flex flex-col justify-between min-h-[75vh] bg-white/80 rounded-[30px] shadow-xl backdrop-blur-md">
      <div className="flex flex-col gap-6 overflow-y-auto flex-grow pr-2 custom-scroll" style={{ maxHeight: '70vh' }}>
        <CareerProgressBar currentLevel={levelNumber} />

        {chatLog.map((msg, idx) => (
          <ChatBubble
            key={idx}
            sender={msg.sender}
            avatar={msg.avatar}
            name={msg.name}
            message={msg.message}
          />
        ))}

        {isThinking && (
          <ChatBubble
            sender="ai"
            avatar={aiAvatar}
            name="Kumar"
            message={<TypingDots />}
          />
        )}

        <div ref={bottomRef} />
      </div>

      <div className="mt-6">
        <MessageInput onSend={handleUserResponse} />
      </div>
    </div>
  );
};

export default Roadmap;
